<template>
  <div v-if="isAuthenticated">
    <div class="header">
      <div class="api-config">
        <input 
          type="text" 
          v-model="apiBaseUrl" 
          placeholder="请输入API接口地址"
          @change="saveApiUrl"
          class="api-input"
        />
        <button @click="saveApiUrl" class="save-btn">保存</button>
      </div>
      <button @click="logout" class="logout-btn">退出登录</button>
    </div>
    11111111
    <input type="date" v-model="selectedDate">
    <label for="startTime">开始时间：</label>
    <select v-model="startTime" ref="startTimeInput">
      <option v-for="time in timeOptions" :key="time" :value="time">{{ formatTimeDisplay(time) }}</option>
    </select>
    <label for="endTime">结束时间：</label>
    <select v-model="endTime" ref="endTimeInput">
      <option v-for="time in timeOptions" :key="time" :value="time">{{ formatTimeDisplay(time) }}</option>
    </select>
    <div>
      <p>{{ timerDisplay }}</p>
    </div>
    <div class="control-panel">
      <label class="switch">
        <input type="checkbox" v-model="allowNonTradingTime">
        <span class="slider round"></span>
      </label>
      <span class="switch-label">允许查询</span>
    </div>
    <h1 @click="playNotification">查询</h1>
    <button @click="getjj">jj</button>
    <button @click="start">查询</button>
    <button @click="stop">停止查询</button>
    <button @click="clearResults">清空</button>
    <button @click="downloadResults">下载结果</button>
    <audio ref="notificationSound">
      <source src="../assets/bell-congratulations-epic-stock-media-1-00-01.mp3" type="audio/mp3">
      <source src="../assets/bell-congratulations-epic-stock-media-1-00-01.mp3" type="audio/wav">
    </audio>
    <div id="resultBz"></div>
    <div id="resultJJ"></div>
    <div id="result2"></div>
    <div id="result">
      <div class="table-container">
        <table>
          <tr>
            <th @click="sortTable('blockCount')" :class="{ 'sort-asc': sortKey === 'blockCount' && sortOrder === 'asc', 'sort-desc': sortKey === 'blockCount' && sortOrder === 'desc' }">
              板块数量
              <span class="sort-icon">{{ getSortIcon('blockCount') }}</span>
            </th>
            <th @click="sortTable('block')" :class="{ 'sort-asc': sortKey === 'block' && sortOrder === 'asc', 'sort-desc': sortKey === 'block' && sortOrder === 'desc' }">
              板块名称/强度/机构/净额
              <span class="sort-icon">{{ getSortIcon('block') }}</span>
            </th>
            <th @click="sortTable('code')" :class="{ 'sort-asc': sortKey === 'code' && sortOrder === 'asc', 'sort-desc': sortKey === 'code' && sortOrder === 'desc' }">
              代码
              <span class="sort-icon">{{ getSortIcon('code') }}</span>
            </th>
            <th @click="sortTable('name')" :class="{ 'sort-asc': sortKey === 'name' && sortOrder === 'asc', 'sort-desc': sortKey === 'name' && sortOrder === 'desc' }">
              名称
              <span class="sort-icon">{{ getSortIcon('name') }}</span>
            </th>
            <th @click="sortTable('amount')" :class="{ 'sort-asc': sortKey === 'amount' && sortOrder === 'asc', 'sort-desc': sortKey === 'amount' && sortOrder === 'desc' }">
              净额
              <span class="sort-icon">{{ getSortIcon('amount') }}</span>
            </th>
            <th @click="sortTable('compare')" :class="{ 'sort-asc': sortKey === 'compare' && sortOrder === 'asc', 'sort-desc': sortKey === 'compare' && sortOrder === 'desc' }">
              对比净额
              <span class="sort-icon">{{ getSortIcon('compare') }}</span>
            </th>
            <th @click="sortTable('price')" :class="{ 'sort-asc': sortKey === 'price' && sortOrder === 'asc', 'sort-desc': sortKey === 'price' && sortOrder === 'desc' }">
              价格
              <span class="sort-icon">{{ getSortIcon('price') }}</span>
            </th>
            <th @click="sortTable('timeRange')" :class="{ 'sort-asc': sortKey === 'timeRange' && sortOrder === 'asc', 'sort-desc': sortKey === 'timeRange' && sortOrder === 'desc' }">
              查询时间
              <span class="sort-icon">{{ getSortIcon('timeRange') }}</span>
            </th>
            <th @click="sortTable('time')" :class="{ 'sort-asc': sortKey === 'time' && sortOrder === 'asc', 'sort-desc': sortKey === 'time' && sortOrder === 'desc' }">
              时间
              <span class="sort-icon">{{ getSortIcon('time') }}</span>
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in datas.second_api" 
              :key="index" 
              :id="'row-' + index"
              :class="{ 'new-row': item.isNew }"
              :style="{ 
                backgroundColor: colorsMap[item.currentAll2 && item.currentAll2[1]] || '#FFFFFF', 
                color: getTextColor(colorsMap[item.currentAll2 && item.currentAll2[1]] || '#FFFFFF'),
                border: item.isNew ? '2px solid red' : '1px solid black'
              }">
            <td>{{ getBlockStockCount(item.currentAll2 && item.currentAll2[1]) }}</td>
            <td>（{{ item.currentAll2 && item.currentAll2[1] ? item.currentAll2[1] : 'N/A' }} + {{ item[4] !== undefined ? item[4] : 'N/A' }})
            / <span style="color: darkred;font-size: 10px;font-weight: bolder">{{ item.currentAll2 && item.currentAll2[2] ? item.currentAll2[2] : 'N/A' }}</span>
            / {{ item[2] !== undefined ? item[2] : 'N/A' }}
            / <span style="color: darkred;font-size: 10px;font-weight: bolder">{{ item.currentAll2 && item.currentAll2[6] ? formatNumber(item.currentAll2[6]) : 'N/A' }}</span>
          / <span style="color: darkred;font-size: 10px;font-weight: bolder">{{ item.currentAll2 && item.currentAll2[3] ? item.currentAll2[3] : 'N/A' }}%</span>
          </td>
            <td @click="copyToClipboard('copyable1' + index)">{{ item[0] !== undefined ? item[0] : 'N/A' }}</td>
            <td>{{ item[1] !== undefined ? item[1] : 'N/A' }}{{ item[6] !== undefined ? item[6] : 'N/A' }}%</td>
            <td><span style="color: darkred;font-size: 10px;font-weight: bolder">{{ formatNumber(item[13] !== undefined ? item[13] : 0) }}</span></td>
            <td><span style="color: red; display: block; white-space: nowrap; font-size: 9px;">昨日：{{ formatNumber(item[23] !== undefined ? item[23] : 0) }}</span>
                <span style="color: red; display: block; white-space: nowrap; font-size: 9px;">今日：{{ formatNumber(item[24] !== undefined ? item[24] : 0) }}</span>
            </td>
            <td>{{ item[5] !== undefined ? item[5] : 'N/A' }}</td>
            <td>{{ item.startTime && item.endTime ? `${formatTimeDisplay(item.startTime)}-${formatTimeDisplay(item.endTime)}` : 'N/A' }}</td>
            <td>{{ item[63] !== undefined ? formatDateTime(item[63]) : 'N/A' }}</td>
            <td class="buyC">
                <span @click="buy(item)">购买</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="login-prompt">
      <p>请先登录...</p>
      <router-link to="/login" class="login-link">点击这里登录</router-link>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      isAuthenticated: false,
      selectedDate: '',
      startTime: '0925',
      endTime: '0930',
      timerDisplay: '',
      timeOptions: [], // 存储时间选项
      all: [],
      all2: [],
      currentStart: '0925',
      currentEnd: '0930',
      timerInterval: null,
      colorsMap: {},
      buyA: [],
      num: 0,
      map: new Map(),
      unique_data: [],
      datas: { second_api: [] },
      isFetching: false,
      apiBaseUrl: localStorage.getItem('apiBaseUrl') || 'https://gpb-7dpb.onrender.com', // 添加API基础URL
      blockColors: [
        '#FFB6C1', // 浅粉红
        '#98FB98', // 浅绿
        '#87CEFA', // 浅天蓝
        '#DDA0DD', // 梅红
        '#F0E68C', // 卡其布
        '#E6E6FA', // 淡紫
        '#FFA07A', // 浅鲑鱼色
        '#98FB98', // 浅绿
        '#87CEEB', // 天蓝
        '#D8BFD8', // 蓟色
        '#FFE4B5', // 莫卡辛
        '#E0FFFF', // 淡青
        '#F5F5DC', // 米色
        '#FFE4E1', // 薄雾玫瑰
        '#F0FFF0'  // 蜜瓜绿
      ],
      blockKeywords: new Map(), // 用于存储板块关键词映射
      allowNonTradingTime: false, // 是否允许非交易时间查询
      sortKey: '', // 当前排序的列
      sortOrder: 'asc', // 排序方向
    };
  },
  watch: {
    startTime(newVal) {
      // 确保结束时间不早于开始时间
      if (this.endTime < newVal) {
        this.endTime = newVal;
      }
    },
    endTime(newVal) {
      // 确保开始时间不晚于结束时间
      if (this.startTime > newVal) {
        this.startTime = newVal;
      }
    }
  },
  created() {
    // 检查登录状态
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    this.isAuthenticated = !!isLoggedIn
  },
  methods: {
    playNotification() {
      this.$refs.notificationSound.play();
    },
    downloadResults() {
      const table = this.$el.querySelector('#result table');
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}_${String(today.getHours()).padStart(2, '0')}-${String(today.getMinutes()).padStart(2, '0')}`;
      if (table) {
        // 创建工作簿
        const workbook = XLSX.utils.book_new();
        
        // 转换表格数据
        const ws = XLSX.utils.table_to_sheet(table, {raw: true});
        
        // 设置列宽
        const colWidths = [
          {wch: 30}, // 板块数量
          {wch: 30}, // 板块名称/强度/机构/净额
          {wch: 10}, // 代码
          {wch: 15}, // 名称
          {wch: 15}, // 净额
          {wch: 20}, // 对比净额
          {wch: 10}, // 价格
          {wch: 20}, // 开始时间
          {wch: 20}, // 结束时间
          {wch: 20}, // 时间
          {wch: 10}  // 操作
        ];
        ws['!cols'] = colWidths;

        // 设置单元格样式
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; R++) {
          for (let C = range.s.c; C <= range.e.c; C++) {
            const cell_address = {c: C, r: R};
            const cell_ref = XLSX.utils.encode_cell(cell_address);
            if (!ws[cell_ref]) continue;

            // 获取原始单元格的背景色
            const originalCell = table.rows[R].cells[C];
            const backgroundColor = originalCell.style.backgroundColor;
            
            // 设置Excel单元格样式
            ws[cell_ref].s = {
              font: { sz: 11 },
              alignment: { horizontal: 'left', vertical: 'center' },
              fill: { fgColor: { rgb: backgroundColor ? backgroundColor.replace('#', '') : 'FFFFFF' } },
              border: {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' }
              }
            };

            // 如果是净额列，设置字体大小和颜色
            if (C === 3) {
              ws[cell_ref].s.font = { sz: 14, color: { rgb: '8B0000' }, bold: true };
            }

            // 如果是时间列，确保格式正确
            if (C === 6 && ws[cell_ref].v) {
              ws[cell_ref].t = 'd';
              ws[cell_ref].z = 'yyyy-mm-dd hh:mm:ss';
            }
          }
        }

        // 添加工作表到工作簿
        XLSX.utils.book_append_sheet(workbook, ws, '股票信息');
        
        // 导出文件
        XLSX.writeFile(workbook, `${formattedDate}股票信息.xlsx`);
      }
    },
    clearResults() {
      this.datas.second_api = [];
    },
    stop() {
      clearInterval(this.timerInterval);
    },
    start() {
      this.currentStart = this.removeColonFromTime(this.startTime || "0925");
      this.currentEnd = this.removeColonFromTime(this.endTime || "0930");

      // 检查当前时间是否超过15:05
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const isAfter1505 = currentHour > 15 || (currentHour === 15 && currentMinute > 5);
      
      // 检查是否在中午休息时间（11:30-13:00）
      const isLunchTime = (currentHour === 11 && currentMinute >= 30) || (currentHour === 12);

      // 如果不允许非交易时间查询，则检查时间
      if (!this.allowNonTradingTime) {
        if (isAfter1505) {
          console.log('当前时间已超过15:05，停止请求');
          return;
        }

        if (isLunchTime) {
          console.log('当前时间在中午休息时间（11:30-13:00），停止请求');
          return;
        }
      }

      // 检查查询时间是否超过11:30
      const queryStartHour = parseInt(this.currentStart.slice(0, 2));
      const queryStartMinute = parseInt(this.currentStart.slice(2));
      const isAfterLunch = queryStartHour > 11 || (queryStartHour === 11 && queryStartMinute > 30);

      // 如果当前时间超过15:00且查询时间超过11:30，则从13:00开始查询
      if (isAfter1505 && isAfterLunch) {
        this.currentStart = "1300";
        this.currentEnd = "1305";
      }

      clearInterval(this.timerInterval);

      this.timerInterval = setInterval(() => {
        const now = new Date();
        const nowTime = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
        
        // 如果不允许非交易时间查询，则检查时间
        if (!this.allowNonTradingTime) {
          // 检查是否超过15:05
          if (now.getHours() > 15 || (now.getHours() === 15 && now.getMinutes() > 5)) {
            console.log('当前时间已超过15:05，停止请求');
            clearInterval(this.timerInterval);
            return;
          }

          // 检查是否在中午休息时间
          if ((now.getHours() === 11 && now.getMinutes() >= 30) || now.getHours() === 12) {
            console.log('当前时间在中午休息时间（11:30-13:00），停止请求');
            clearInterval(this.timerInterval);
            return;
          }
        }

        if ((this.timeDifferenceInMinutes(nowTime, this.currentEnd) < 6 && this.isToday(this.selectedDate)) || (this.timeDifferenceInMinutes(nowTime, this.currentEnd) < 6 && !this.selectedDate)) {
          let currentMinute = Math.floor(now.getMinutes() / 5) * 5;
          let currentHour = now.getHours();

          this.currentEnd = `${String(currentHour).padStart(2, '0')}${String(currentMinute).padStart(2, '0')}`;

          currentMinute -= 5;
          if (currentMinute < 0) {
            currentMinute = 55;
            currentHour -= 1;
          }
          this.currentStart = `${String(currentHour).padStart(2, '0')}${String(currentMinute).padStart(2, '0')}`;
        } else if (6 > this.timeDifferenceInMinutes(nowTime, this.currentEnd) || !this.isToday(this.selectedDate)) {
          const startHour = parseInt(this.currentStart.slice(0, 2), 10);
          const startMinute = parseInt(this.currentStart.slice(2), 10);
          const endHour = parseInt(this.currentEnd.slice(0, 2), 10);
          const endMinute = parseInt(this.currentEnd.slice(2), 10);

          let newStartMinute = startMinute + 5;
          let newEndMinute = endMinute + 5;

          let newStartHour = startHour;
          let newEndHour = endHour;

          if (newStartMinute >= 60) {
            newStartMinute -= 60;
            newStartHour++;
          }
          if (newEndMinute >= 60) {
            newEndMinute -= 60;
            newEndHour++;
          }

          this.currentStart = `${String(newStartHour).padStart(2, '0')}${String(newStartMinute).padStart(2, '0')}`;
          this.currentEnd = `${String(newEndHour).padStart(2, '0')}${String(newEndMinute).padStart(2, '0')}`;
        }

        this.fetchData(this.currentStart, this.currentEnd, this.selectedDate);
      }, 5000);
    },
    getjj() {
      this.fetchJJData();
    },
    removeColonFromTime(timeStr) {
      return timeStr.replace(":", "");
    },
    timeDifferenceInMinutes(time1, time2) {
      const hours1 = parseInt(time1.substring(0, 2));
      const minutes1 = parseInt(time1.substring(2, 4));
      const hours2 = parseInt(time2.substring(0, 2));
      const minutes2 = parseInt(time2.substring(2, 4));

      const date1 = new Date();
      date1.setHours(hours1, minutes1, 0);

      const date2 = new Date();
      date2.setHours(hours2, minutes2, 0);

      return Math.floor((date1 - date2) / (1000 * 60));
    },
    isToday(dateStr) {
      const today = new Date();
      const inputDate = new Date(dateStr);
      return (
        inputDate.getDate() === today.getDate() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
      );
    },
    async fetchData(startTime, endTime, selectedDate) {
      if (this.isFetching) {
        console.log('上一次请求还未完成，跳过本次请求');
        return;
      }

      console.log("Fetching data...");
      this.isFetching = true;
      
      try {
        let params = {
          "Index": 0,
          "Order": 1,
          "PhoneOSNew": 2,
          "REnd": endTime || this.currentEnd,
          "RStart": startTime || this.currentStart,
          "Type": 5,
          "VerSion": "5.15.0.3",
          "ZSType": 7,
          "a": "RealRankingInfo",
          "apiv": "w37",
          "c": "ZhiShuRanking",
          "st": 20
        };

        if (startTime && endTime && selectedDate) {
          params = {
            "REnd": endTime || this.currentEnd,
            "RStart": startTime || this.currentStart,
            'Date': selectedDate,
            'Index': 0,
            'Order': 1,
            'PhoneOSNew': 2,
            'Type': 1,
            'VerSion': '5.15.0.3',
            'ZSType': 7,
            'a': 'RealRankingInfo',
            'apiv': 'w37',
            'c': 'ZhiShuRanking',
            'st': 20
          };
          params["type"] = true;
        }

        const url = location.hostname.indexOf("localhost") !== -1 
          ? 'http://127.0.0.1:5000/api/data'
          : `${this.apiBaseUrl}/api/data`;

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36',
            'Origin': 'https://apphis.longhuvip.com',
            'Referer': 'https://apphis.longhuvip.com/'
          },
          body: JSON.stringify(params)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // 检查响应的Content-Type
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.error('服务器返回了非JSON格式的响应:', contentType);
          throw new Error('服务器返回了非JSON格式的响应');
        }

        const datas = await response.json();
        
        // 检查返回的数据结构
        if (!datas || typeof datas !== 'object') {
          console.error('返回的数据格式不正确:', datas);
          throw new Error('返回的数据格式不正确');
        }

        this.num += 1;

        let currentTime = new Date().toLocaleString();
        let useTime = this.currentEnd;
        const now = new Date();
        const nowTime = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
        
        if (this.isToday(selectedDate) && this.timeDifferenceInMinutes(nowTime, this.currentEnd) < 6) {
          useTime = currentTime;
        }
        useTime = currentTime;
        
        if (datas.second_api && datas.second_api.length > 0 && datas.second_api[0]) {
          datas.second_api[0].push(useTime);
          const currentItem = datas.second_api[0];
          
          // 清除之前所有数据的红框标记
          this.datas.second_api.forEach(item => {
            item.isNew = false;
          });
          
          // 查找是否存在相同股票代码的记录
          const existingItemIndex = this.datas.second_api.findIndex(item => item[0] === currentItem[0]);
          
          if (existingItemIndex !== -1) {
            // 如果存在相同股票，检查净额是否变化
            const existingItem = this.datas.second_api[existingItemIndex];
            if (existingItem[13] !== currentItem[13]) {
              // 净额发生变化，更新记录并标记为新数据
              this.datas.second_api[existingItemIndex] = {
                ...currentItem,
                backgroundColor: existingItem.backgroundColor,
                textColor: existingItem.textColor,
                currentAll2: existingItem.currentAll2,
                blockName: existingItem.blockName,
                isNew: true,
                startTime: this.currentStart,
                endTime: this.currentEnd
              };
              
              this.playNotification();
              this.$nextTick(() => {
                document.title = '【有新提醒】';
              });
            }
          } else {
            // 如果是新股票，添加到列表中
            const currentAll2 = datas.first_api || [];
            console.log('currentAll2', currentAll2);
            
            // 获取板块名称
            const blockName = currentAll2[1] || currentItem[4];
            
            // 为新的板块分配颜色
            if (!this.colorsMap[blockName]) {
              this.colorsMap[blockName] = this.getSoftRandomColor();
            }

            const backgroundColor = this.colorsMap[blockName];
            const textColor = this.getTextColor(backgroundColor);

            if (currentItem[24] > Math.abs(currentItem[23])) {
              const trimmedItem = currentItem[1].trim();
              if (!this.buyA.includes(trimmedItem)) {
                this.buyA.push(trimmedItem);
              }
            }
            
            // 找到相同板块的第一个数据
            const firstBlockData = this.datas.second_api.find(item => 
              item.currentAll2 && item.currentAll2[1] === blockName
            );

            // 将新数据追加到现有数据中
            const newData = {
              ...currentItem,
              backgroundColor,
              textColor,
              currentAll2: firstBlockData ? firstBlockData.currentAll2 : currentAll2,
              blockName,
              isNew: true,
              startTime: this.currentStart,
              endTime: this.currentEnd
            };

            // 找到相同板块的位置
            const sameBlockIndex = this.datas.second_api.findIndex(item => 
              item.currentAll2 && item.currentAll2[1] === blockName
            );
            
            if (sameBlockIndex !== -1) {
              // 找到该板块的最后一个位置
              let lastIndex = sameBlockIndex;
              while (lastIndex + 1 < this.datas.second_api.length && 
                     this.datas.second_api[lastIndex + 1].currentAll2 && 
                     this.datas.second_api[lastIndex + 1].currentAll2[1] === blockName) {
                lastIndex++;
              }
              // 将新数据插入到该板块的最后
              this.datas.second_api.splice(lastIndex + 1, 0, newData);
            } else {
              // 如果没有找到相同板块，将新数据追加到末尾
              this.datas.second_api.push(newData);
            }

            this.playNotification();
            this.$nextTick(() => {
              document.title = '【有新提醒】';
            });
          }

          // 重新排序
          this.datas.second_api.sort((a, b) => {
            const blockA = a.currentAll2 ? a.currentAll2[1] : '';
            const blockB = b.currentAll2 ? b.currentAll2[1] : '';
            
            if (blockA === blockB) {
              return new Date(a[63]) - new Date(b[63]);
            }
            return blockA.localeCompare(blockB);
          });

          // 滚动到新数据
          const newIndex = this.datas.second_api.findIndex(item => item.isNew);
          if (newIndex !== -1) {
            this.$nextTick(() => {
              const element = document.getElementById(`row-${newIndex}`);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            });
          }
        } else {
          console.warn('datas.second_api is empty or undefined');
        }
      } catch (error) {
        console.error('请求失败:', error);
        
        // 检查当前时间是否超过15:00
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        const isAfternoon = currentHour > 15 || (currentHour === 15 && currentMinute > 0);

        if (isAfternoon) {
          console.log('下午3点后报错，继续使用当前时间点查询:', this.currentStart, this.currentEnd);
          this.isFetching = false;
          return;
        }

        // 如果未超过15:00，则调整查询时间
        let newMinute = Math.floor(currentMinute / 5) * 5;
        let newHour = currentHour;

        this.currentEnd = `${String(newHour).padStart(2, '0')}${String(newMinute).padStart(2, '0')}`;

        newMinute -= 5;
        if (newMinute < 0) {
          newMinute = 55;
          newHour -= 1;
        }
        this.currentStart = `${String(newHour).padStart(2, '0')}${String(newMinute).padStart(2, '0')}`;

        // 添加重试逻辑
        setTimeout(() => {
          this.fetchData(this.currentStart, this.currentEnd, this.selectedDate);
        }, 5000); // 5秒后重试
      } finally {
        this.isFetching = false;
      }
    },
    fetchJJData() {
      // Implement fetchJJData logic
    },
    copyToClipboard(id) {
      const el = document.getElementById(id);
      if (el) {
        const range = document.createRange();
        range.selectNode(el);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
      }
    },
   async buy(data,type) {
        let infoD = await fetch('http://localhost:5000/api/info', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                StockID: !type?data[0] : data[3]
            }),
        }).then(response => response.json())


        let current_price = infoD.openpx,
            percentage_increase = 9.9
        if(data[5] > 11 || data[6] > 11){
            percentage_increase = 19.99
        }
            let increase_amount = current_price * percentage_increase / 100
            let new_price = current_price + increase_amount
        fetch('http://localhost:5000/api/trade', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                stockCode: !type?data[0] : data[3],
                price: new_price.toFixed(2),
                amount: '100',
                tradeType: 'B',
                zqmc: data[3],
                market: 'SA',
                validatekey: '1d290e50-a589-45ec-967e-35787eb1ef8b',
                gw_reqtimestamp:'1731286690673',
                Cookie:''
            }),
        })
            .then(response => response.json())
           
    },
    assignColorsForBlocks(blockData, columnIndex) {
      if (!blockData || columnIndex === undefined) return;
      
      const blockName = blockData[columnIndex];
      if (!blockName) return;

      if (!this.colorsMap[blockName]) {
        // 为新的板块分配一个颜色
        const colorIndex = Object.keys(this.colorsMap).length % this.blockColors.length;
        this.colorsMap[blockName] = this.blockColors[colorIndex];
      }
    },
    getTextColor(backgroundColor) {
      // 如果是 HSL 颜色
      if (backgroundColor.startsWith('hsl')) {
        const match = backgroundColor.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
        if (match) {
          const lightness = parseInt(match[3]);
          // 如果背景色亮度大于 80%，使用深色文字
          return lightness > 80 ? '#000000' : '#FFFFFF';
        }
      }
      
      // 如果是十六进制颜色
      const hex = backgroundColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      
      // 计算亮度
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      
      // 根据亮度返回黑色或白色
      return brightness > 150 ? '#000000' : '#FFFFFF';
    },
    formatNumber(num) {
      let result;
let numF = ""
if(num <0 ) {
    numF = '-'
    num = num * -1
}
if (num > 100000000) {
    result = numF+''+(num / 100000000).toFixed(1) + '亿';
} else if (num > 10000) {
    result = numF+''+(num / 10000).toFixed(1) + '万';
} else {
    result = num;
}
return result || 0;
    
    },
    normalizeBlockName(blockName) {
      if (!blockName) return '';
      
      // 移除常见的后缀
      const suffixes = ['概念', '板块', '行业', '主题'];
      let normalized = blockName;
      
      // 移除后缀
      for (const suffix of suffixes) {
        normalized = normalized.replace(suffix, '');
      }
      
      // 移除空格和特殊字符
      normalized = normalized.trim().replace(/[^\w\u4e00-\u9fa5]/g, '');

      // 检查是否已经存在包含该关键词的板块
      for (const [existingBlock, keywords] of this.blockKeywords.entries()) {
        if (keywords.some(keyword => normalized.includes(keyword))) {
          return existingBlock;
        }
      }

      // 如果是新的板块，将其添加到关键词映射中
      this.blockKeywords.set(normalized, [normalized]);
      
      return normalized;
    },
    // 生成随机颜色
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    // 生成柔和的随机颜色
    getSoftRandomColor() {
      const hue = Math.floor(Math.random() * 360);
      const saturation = 35 + Math.floor(Math.random() * 25); // 35-60%
      const lightness = 75 + Math.floor(Math.random() * 15); // 75-90%
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
    // 生成时间选项
    generateTimeOptions() {
      const options = [];
      for (let hour = 9; hour <= 15; hour++) {
        for (let minute = 0; minute < 60; minute += 5) {
          const timeStr = `${String(hour).padStart(2, '0')}${String(minute).padStart(2, '0')}`;
          // 跳过非交易时间
          if (hour === 9 && minute < 25) continue;
          if (hour === 11 && minute > 30) continue;
          if (hour === 12) continue;
          if (hour === 13 && minute < 0) continue;
          if (hour === 15 && minute > 0) continue;
          options.push(timeStr);
        }
      }
      this.timeOptions = options;
    },
    // 格式化时间显示
    formatTimeDisplay(time) {
      if (!time) return '';
      const hour = time.substring(0, 2);
      const minute = time.substring(2, 4);
      return `${hour}:${minute}`;
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return 'N/A';
      const date = new Date(dateTimeStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    sortTable(key) {
      if (this.sortKey === key) {
        // 如果点击的是当前排序的列，切换排序方向
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        // 如果是新的列，设置为升序
        this.sortKey = key;
        this.sortOrder = 'asc';
      }

      this.datas.second_api.sort((a, b) => {
        let valueA, valueB;
        let blockA, blockB, countA, countB;

        switch (key) {
          case 'blockCount':
            valueA = this.getBlockStockCount(a.currentAll2 && a.currentAll2[1]);
            valueB = this.getBlockStockCount(b.currentAll2 && b.currentAll2[1]);
            break;
          case 'block':
            // 获取每个板块的股票数量
            blockA = a.currentAll2 ? a.currentAll2[1] : '';
            blockB = b.currentAll2 ? b.currentAll2[1] : '';
            
            // 计算每个板块的股票数量
            countA = this.datas.second_api.filter(item => 
              item.currentAll2 && item.currentAll2[1] === blockA
            ).length;
            
            countB = this.datas.second_api.filter(item => 
              item.currentAll2 && item.currentAll2[1] === blockB
            ).length;
            
            // 首先按数量排序
            if (countA !== countB) {
              valueA = countA;
              valueB = countB;
            } else {
              // 如果数量相同，则按板块名称排序
              valueA = blockA;
              valueB = blockB;
            }
            break;
          case 'code':
            valueA = a[0] || '';
            valueB = b[0] || '';
            break;
          case 'name':
            valueA = a[1] || '';
            valueB = b[1] || '';
            break;
          case 'amount':
            valueA = a[13] || 0;
            valueB = b[13] || 0;
            break;
          case 'compare':
            valueA = a[24] || 0;
            valueB = b[24] || 0;
            break;
          case 'price':
            valueA = parseFloat(a[5]) || 0;
            valueB = parseFloat(b[5]) || 0;
            break;
          case 'timeRange':
            valueA = (a.startTime || '') + (a.endTime || '');
            valueB = (b.startTime || '') + (b.endTime || '');
            break;
          case 'time':
            valueA = new Date(a[63] || 0);
            valueB = new Date(b[63] || 0);
            break;
          default:
            return 0;
        }

        if (this.sortOrder === 'asc') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });
    },
    getSortIcon(key) {
      if (this.sortKey !== key) return '↕';
      return this.sortOrder === 'asc' ? '↑' : '↓';
    },
    getBlockStockCount(blockName) {
      if (!blockName) return 0;
      return this.datas.second_api.filter(item => 
        item.currentAll2 && item.currentAll2[1] === blockName
      ).length;
    },
    logout() {
      localStorage.removeItem('isLoggedIn')
      this.isAuthenticated = false
      window.location.href = '/login'
    },
    saveApiUrl() {
      // 保存API URL到localStorage
      localStorage.setItem('apiBaseUrl', this.apiBaseUrl);
      // 显示保存成功提示
      alert('API地址保存成功');
    },
  },
  mounted() {
    this.generateTimeOptions();
  }
};
</script>

<style scoped>
/* 基础表格样式 */
.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0;
  padding: 0;
}

table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  background: white;
  font-size: 14px;
}

table, th, td {
  border: 1px solid #ddd;
}

th, td {
  padding: 8px;
  text-align: left;
  white-space: nowrap;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: 5px;
    padding: 0.3rem;
  }

  .api-config {
    width: 100%;
  }

  .api-input {
    width: 100%;
    max-width: none;
    font-size: 9px;
    padding: 4px;
  }

  .control-panel {
    flex-wrap: wrap;
    gap: 3px;
  }

  /* 修改表格容器样式 */
  .table-container {
    width: 100%;
    overflow-x: visible;
    margin: 0;
    padding: 0;
  }

  table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  th, td {
    padding: 3px;
    font-size: 9px;
    line-height: 1.2;
    white-space: normal;
    word-break: break-all;
  }

  /* 调整列宽 */
  th:nth-child(1), td:nth-child(1) { width: 8%; }  /* 板块数量 */
  th:nth-child(2), td:nth-child(2) { width: 25%; } /* 板块名称/强度/机构/净额 */
  th:nth-child(3), td:nth-child(3) { width: 10%; } /* 代码 */
  th:nth-child(4), td:nth-child(4) { width: 12%; } /* 名称 */
  th:nth-child(5), td:nth-child(5) { width: 12%; } /* 净额 */
  th:nth-child(6), td:nth-child(6) { width: 15%; } /* 对比净额 */
  th:nth-child(7), td:nth-child(7) { width: 8%; }  /* 价格 */
  th:nth-child(8), td:nth-child(8) { width: 10%; } /* 查询时间 */
  th:nth-child(9), td:nth-child(9) { width: 10%; } /* 时间 */
  th:nth-child(10), td:nth-child(10) { width: 8%; } /* 操作 */

  /* 调整对比净额显示 */
  td:nth-child(6) {
    white-space: normal !important;
    word-break: break-all;
  }

  td:nth-child(6) span {
    display: block;
    white-space: normal !important;
    word-break: break-all;
    font-size: 9px;
    line-height: 1.2;
  }

  /* 调整板块信息显示 */
  td:nth-child(2) {
    font-size: 9px;
    white-space: normal;
    word-break: break-all;
  }

  /* 调整所有单元格的换行 */
  th, td {
    padding: 3px;
    font-size: 9px;
    line-height: 1.2;
    white-space: normal !important;
    word-break: break-all;
  }

  /* 调整表格布局 */
  table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  /* 调整列宽 */
  th:nth-child(1), td:nth-child(1) { width: 8%; }  /* 板块数量 */
  th:nth-child(2), td:nth-child(2) { width: 25%; } /* 板块名称/强度/机构/净额 */
  th:nth-child(3), td:nth-child(3) { width: 10%; } /* 代码 */
  th:nth-child(4), td:nth-child(4) { width: 12%; } /* 名称 */
  th:nth-child(5), td:nth-child(5) { width: 12%; } /* 净额 */
  th:nth-child(6), td:nth-child(6) { width: 15%; } /* 对比净额 */
  th:nth-child(7), td:nth-child(7) { width: 8%; }  /* 价格 */
  th:nth-child(8), td:nth-child(8) { width: 10%; } /* 查询时间 */
  th:nth-child(9), td:nth-child(9) { width: 10%; } /* 时间 */
  th:nth-child(10), td:nth-child(10) { width: 8%; } /* 操作 */

  /* 调整特殊文字大小 */
  td span[style*="font-size: 25px"] {
    font-size: 10px !important;
  }

  /* 调整按钮和输入框文字 */
  button {
    padding: 4px 8px;
    font-size: 9px;
  }

  input[type="date"],
  select {
    padding: 4px;
    font-size: 9px;
  }

  /* 调整标题文字 */
  h1 {
    font-size: 11px;
    margin: 5px 0;
  }

  /* 调整标签文字 */
  label {
    font-size: 9px;
  }

  /* 调整开关标签文字 */
  .switch-label {
    font-size: 9px;
    margin-left: 5px;
  }

  /* 调整按钮文字 */
  .save-btn, .logout-btn {
    padding: 4px 8px;
    font-size: 9px;
  }
}

/* 保持其他现有样式 */
.buyC {
  white-space: nowrap;
  display: block;
  margin: 5px 0;
}

.control-panel {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch-label {
  margin-left: 10px;
  font-size: 14px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.api-config {
  display: flex;
  align-items: center;
  gap: 10px;
}

.api-input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 300px;
  font-size: 14px;
}

.save-btn {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.save-btn:hover {
  background-color: #45a049;
}

.logout-btn {
  padding: 0.5rem 1rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.logout-btn:hover {
  background-color: #c82333;
}

.login-prompt {
  text-align: center;
  margin-top: 50px;
}

.login-link {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #2196F3;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.login-link:hover {
  background-color: #1976D2;
}
</style>
